import { render, staticRenderFns } from "./ChannelAccess.vue?vue&type=template&id=747b2c98&scoped=true&"
import script from "./ChannelAccess.vue?vue&type=script&lang=ts&"
export * from "./ChannelAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747b2c98",
  null
  
)

export default component.exports